import { resizeElement } from './handle-element.es.js';
import { resizeWindow } from './handle-window.es.js';

function resize(a, b) {
    return typeof a === "function" ? resizeWindow(a) : resizeElement(a, b);
}

export { resize };



//////////////////
// WEBPACK FOOTER
// ./node_modules/@motionone/dom/dist/gestures/resize/index.es.js
// module id = fpld
// module chunks = 0